export default {
	MANUAL: 0,
	AUTO: 1,
	EXTERNAL_STARTED: 2,
	AUTO2: 3,
	EXTERNAL: 4,
};
